import type { FormValues, NormalizedFormValues } from '#src/app/pages/petitionDetails/shared/types';

export function normalizeCaptcha({
	recaptchaResponse,
}: Pick<FormValues, 'recaptchaResponse'>): NormalizedFormValues['recaptchaResponse'] {
	return recaptchaResponse || null;
}
